import { styled } from '@mui/material';
import { Icon } from 'assets/Icon.js';

const IssueFormTabLabelError = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const IssueFormTabLabel = (props: { label: string; hasError: boolean }) => {
  if (props.hasError) {
    return (
      <IssueFormTabLabelError>
        {props.label}
        {' '}
        <Icon icon="warningCircleSvg" />
      </IssueFormTabLabelError>
    );
  } else {
    return props.label;
  }
};
